// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"664ee3a8","598":"a8205efe","703":"3d75b398"}[chunkId] + ".chunk.js";
};